module.exports = __WEBPACK_EXTERNAL_MODULE_156__;


//////////////////
// WEBPACK FOOTER
// external "comsMobx"
// module id = 156
// module chunks = 0